// Decision de acceso de un cliente al portal.
//
// ┌─ POR QUE ESTE ARCHIVO EXISTE ────────────────────────────────────────────────┐
// │ 🔴 LA PROTECCION EXISTIA Y NO PROTEGIA.                                      │
// │                                                                              │
// │ `AuthContext` sabe expresar «tu acceso al portal no esta activo»: la pantalla │
// │ esta escrita y el chequeo de estados existe. Pero vivia SOLO dentro de        │
// │ `createClientPortalUserFromCliente`, que corre en la rama de FALLBACK — la    │
// │ que se usa cuando NO hay fila en `profiles`.                                  │
// │                                                                              │
// │ Con el perfil presente —el caso normal de todo cliente aprovisionado—         │
// │ `fetchProfile` retornaba antes, decidiendo el acceso con `profiles.role` y    │
// │ NADA MAS. La ficha del cliente no participaba de la decision.                 │
// │                                                                              │
// │ Consecuencia medida en el codigo: `archiveCliente` (CRM) escribe SOLO         │
// │ `archived_at`; no toca el rol, ni la sesion, ni el acceso. Un cliente         │
// │ archivado —o con el acceso revocado— seguia entrando al portal con todo.      │
// └──────────────────────────────────────────────────────────────────────────────┘
//
// ⚠️ REGLA DE DIRECCION: la AUSENCIA de ficha NO bloquea.
// Solo niega el acceso una ficha ENCONTRADA y explicitamente cerrada por el staff.
// Es deliberado: durante el aprovisionamiento existe una ventana real en la que el
// perfil ya existe y `clientes.portal_user_id` todavia es null (`_shared/client-access.ts`
// crea el perfil en :504 y recien enlaza en :518, con dos envios de por medio).
// Bloquear por ausencia convertiria esa ventana en un portazo al cliente nuevo.

// Estados que el staff usa para cerrar un acceso. `archived_at` cuenta como cierre.
export const ESTADOS_QUE_NIEGAN_ACCESO = [
  'revocado', 'revoked', 'bloqueado', 'blocked', 'suspendido', 'suspended',
];

// 'bloqueado' → la ficha existe y niega el acceso.
// 'ok'        → la ficha existe y lo permite.
// 'sin_ficha' → no hay ficha que consultar; NO es una negacion (ver regla de direccion).
export function decidirAccesoDeCliente(cliente) {
  if (!cliente || !cliente.id) return 'sin_ficha';
  if (cliente.archived_at) return 'bloqueado';
  const estado = String(cliente.portal_access_status || '').toLowerCase();
  return ESTADOS_QUE_NIEGAN_ACCESO.includes(estado) ? 'bloqueado' : 'ok';
}

// Un cliente puede llegar al portal por DOS vias: como dueño de la ficha
// (`clientes.portal_user_id`) o como participante con membresia activa
// (`client_portal_members`). La primera cubre al que compro; la segunda al cofirmante o
// invitado que el estudio agrego.
//
// 🔴 Cubrir solo la primera deja media promesa sin cumplir: archivar un cliente le quitaba
// el acceso al dueño y NO a sus participantes, que seguian entrando al portal de una ficha
// archivada. `ClientPortal` nunca mira `archived_at`, y `archiveCliente` no toca las filas
// de miembros.
//
// Manda la PRIMERA fuente que encuentra ficha. Si ninguna encuentra, no se bloquea:
// la regla de direccion de arriba vale igual.
export function decidirAccesoDeClienteConMembresia(fichaDelDueno, fichaPorMembresia) {
  const porDueno = decidirAccesoDeCliente(fichaDelDueno);
  return porDueno === 'sin_ficha' ? decidirAccesoDeCliente(fichaPorMembresia) : porDueno;
}
